import { fetcher } from "utils";

import { IMembersOrderPointsSimple } from "typings";

export const get__members__order_points__simple = (): Promise<IMembersOrderPointsSimple> =>
  fetcher.get("/members/order_points/simple");
